import styled from 'styled-components'

const MainLayout = styled.div`
  flex: 1 1;
  display: flex;
  flex-direction: row;
  & > div {
    flex: 1 1;
    display: flex;
    flex-direction: column;
  }
`
export default {
  MainLayout,
}
